/** Haalt ALLEEN de `share`-parameter uit een URL en laat andere parameters en #hash intact. */
export function removeShareParam(href: string): { value: string | null; cleanedUrl: string } {
  const url = new URL(href);
  const value = url.searchParams.get('share');
  if (value === null) return { value: null, cleanedUrl: href };
  url.searchParams.delete('share');
  return { value, cleanedUrl: `${url.pathname}${url.search}${url.hash}` };
}
